import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CaseStudyOverview from '../caseStudies/caseStudyOverview';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';

const CaseStudyResults = ({data}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                className="sectionSpacing"
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    p: {xs: 2, md: 5}
                }}
                borderRadius={6}
            >
                <CaseStudyOverview 
                    title={t('caseStudies.results')}
                    data={data}
                    footer={<>
                        <Grid
                            direction='row'
                            justifyContent='start'
                            alignItems='start'
                            container
                            pt={{xs: 5, md: 5}}
                            spacing={2}
                        >
                            {
                                data.insights.map((item, index) => {
                                    return <Grid
                                        key={index}
                                        size={{xs: 6, md: 4}}
                                    >
                                        <Stack
                                            direction='column'
                                            justifyContent='start'
                                            alignItems='center'
                                            position='relative'
                                        >
                                            <Gauge
                                                width={100}
                                                height={100}
                                                value={item.value}
                                                cornerRadius="50%"
                                                sx={(theme) => ({
                                                    [`& .${gaugeClasses.valueText}`]: {
                                                        fontSize: 40,
                                                        fontFamily: theme.typography.fontFamily,
                                                        display: 'none'
                                                    },
                                                    [`& .${gaugeClasses.valueArc}`]: {
                                                        fill: theme.palette.primary.main,
                                                    },
                                                    [`& .${gaugeClasses.referenceArc}`]: {
                                                        fill: theme.palette.background.default,
                                                    },
                                                })}
                                            />

                                            <Typography
                                                fontWeight={600}
                                                fontSize={16}
                                                textAlign='left'
                                                color={theme.palette.text.primary}
                                                lineHeight={1.5}
                                                position='absolute'
                                                top={40}
                                            >
                                                {`+${item.value}%`}
                                            </Typography>
                                                
                                            <Typography
                                                fontWeight={500}
                                                fontSize={{xs: 10, md: 12}}
                                                textAlign="center"
                                                lineHeight={1.5}
                                                color={theme.palette.text.secondary}
                                            >
                                                {item.label}
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                })
                            }
                            <Grid>

                            </Grid>
                        </Grid>
                    </>}
                    leftPanelMdSize={4}
                />
            </Box>
        </>
    );
}

export default CaseStudyResults;